var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.relatedInfo.length > 0)?_vm._t("container",null,{"list":_vm.relatedInfo}):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }